<template>
<Layout heading-text="SysAdmin Admin View" v-if="type === 'admin'">
  <h1 class="text-center pb-0 text-xl font-bold text-blue-600 sm:text-left md:text-center lg:text-center xl:text-center"></h1>
  <br>
  <div class="hidden sm:hidden md:visible lg:visible xl:visible flex justify-start sm:flex justify md:flex content-center lg:flex content-center xl:flex content-center text-center">
    <ul class="flex-1 sm:flex-wrap md:flex content-center lg:flex content-center xl:flex content-center  border-b ...">
      <li class="mr-1 mt-2 pt-1" :class="{ '-mb-px': tab === 'allusers' }">
        <button
          :class="{
            'inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out':
              tab === 'allusers',
            'bg-white inline-block py-2 px-4 text-blue-500 hover:text-red-600 font-semibold':
              tab !== 'allusers',
          }"
          v-on:click="setTab('allusers');"
        >
          All Schedules
        </button>
      </li>

    
      </ul>
    </div>
  <span>
  </span>
    <br>
    <!--Web Version-->
    <div class="hidden md:block">
    <div class="md:hidden lg:hidden xl:hidden sm:visible">
    <div v-if="tab === 'allusers'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%23616161&ctz=Africa%2FJohannesburg&showTitle=0&showPrint=0&showCalendars=0&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ODE3ODI2OGM0YTAyMDlmMjg1OTQxNDM1MzU1YzkwMzEwZjlmZDMzNWM2MjQ1ZDUxNzEzZDkyYzU3ZTU5ZDUwMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MTc0ZjA5OThiNmZmNmJkMjNiNmU1ZTM5OWFhN2RlOTE4NTVjNzMwYzhmNTk5YThmMDliODNlZDc4ZmRjNmZlZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MmRmMmVhNjdkMDk4ZGY0MzJhYWZhMWEzOTI5YTI0NDBlYzBhOTcyZDczYTBhMjhiOWYyZGEwZWY3NjFlYWNjZEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=YzQxMGNmMDA4MDcyYzQ5NzNhNGZkMzNhNDBmNWUyM2EwYzcyNmE2YWU1YWU0OTYzNzkzYjg3NDFkZjk2YzY1YkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D81B60&color=%23F6BF26&color=%234285F4&color=%23EF6C00&color=%230B8043" style="border:solid 1px #777" width="350" height="800" frameborder="0" scrolling="yes"></iframe>
    </div>
    </div>
    <div class="invisible md:visible lg:visible xl:visible">
  <div v-if="tab === 'allusers'">
 
    <iframe src="https://calendar.google.com/calendar/embed?height=940&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&showTitle=0&src=MmRmMmVhNjdkMDk4ZGY0MzJhYWZhMWEzOTI5YTI0NDBlYzBhOTcyZDczYTBhMjhiOWYyZGEwZWY3NjFlYWNjZEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ODE3ODI2OGM0YTAyMDlmMjg1OTQxNDM1MzU1YzkwMzEwZjlmZDMzNWM2MjQ1ZDUxNzEzZDkyYzU3ZTU5ZDUwMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=OTliNmY3YzdmYmJkMjIzY2QzOTk3ZDkyNTIyMzA3Yzg0MmY4OGJiZmYzMGEwZGY4M2U3YzliODE5OWIwYzZiMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MTc0ZjA5OThiNmZmNmJkMjNiNmU1ZTM5OWFhN2RlOTE4NTVjNzMwYzhmNTk5YThmMDliODNlZDc4ZmRjNmZlZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=YzQxMGNmMDA4MDcyYzQ5NzNhNGZkMzNhNDBmNWUyM2EwYzcyNmE2YWU1YWU0OTYzNzkzYjg3NDFkZjk2YzY1YkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23EF6C00&color=%23F6BF26&color=%239E69AF&color=%234285F4&color=%23F6BF26&color=%230B8043" style="border:solid 1px #777" width="1215" height="940" frameborder="0" scrolling="no"></iframe>
  </div>
  <div v-if="tab === 'travis'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%230B8043&ctz=Africa%2FJohannesburg&showTitle=0&showPrint=0&showCalendars=0&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=YzQxMGNmMDA4MDcyYzQ5NzNhNGZkMzNhNDBmNWUyM2EwYzcyNmE2YWU1YWU0OTYzNzkzYjg3NDFkZjk2YzY1YkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D81B60&color=%230B8043" style="border:solid 1px #777" width="1215" height="800" frameborder="0" scrolling="no"></iframe>
  </div>
  <div v-if="tab === 'danito'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%23EF6C00&ctz=Africa%2FJohannesburg&showTitle=0&showPrint=0&showCalendars=0&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MmRmMmVhNjdkMDk4ZGY0MzJhYWZhMWEzOTI5YTI0NDBlYzBhOTcyZDczYTBhMjhiOWYyZGEwZWY3NjFlYWNjZEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D81B60&color=%23EF6C00" style="border:solid 1px #777" width="1215" height="800" frameborder="0" scrolling="no"></iframe>
  </div>
  <div v-if="tab === 'eugene'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%234285F4&ctz=Africa%2FJohannesburg&showTitle=0&showPrint=0&showCalendars=0&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MTc0ZjA5OThiNmZmNmJkMjNiNmU1ZTM5OWFhN2RlOTE4NTVjNzMwYzhmNTk5YThmMDliODNlZDc4ZmRjNmZlZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D81B60&color=%234285F4" style="border:solid 1px #777" width="1215" height="800" frameborder="0" scrolling="no"></iframe>
  </div>
  <div v-if="tab === 'elrich'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%23F6BF26&ctz=Africa%2FJohannesburg&showTitle=0&showPrint=0&showCalendars=0&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ODE3ODI2OGM0YTAyMDlmMjg1OTQxNDM1MzU1YzkwMzEwZjlmZDMzNWM2MjQ1ZDUxNzEzZDkyYzU3ZTU5ZDUwMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D81B60&color=%23F6BF26" style="border:solid 1px #777" width="1215" height="800" frameborder="0" scrolling="no"></iframe>
  </div>
  <div v-if="tab === 'ethan'">
    <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&showTitle=0&src=OTliNmY3YzdmYmJkMjIzY2QzOTk3ZDkyNTIyMzA3Yzg0MmY4OGJiZmYzMGEwZGY4M2U3YzliODE5OWIwYzZiMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%239E69AF" style="border:solid 1px #777" width="1215" height="800" frameborder="0" scrolling="no"></iframe>
  </div>
  </div>
</div>
<!--Mobile Version-->
  <div class="block md:hidden lg:hidden">
    <div class="md:hidden lg:hidden xl:hidden sm:visible">
    <div v-if="tab === 'allusers'">
<iframe src="https://calendar.google.com/calendar/embed?height=500&wkst=1&ctz=Africa%2FJohannesburg&showPrint=0&showTitle=0&showTz=0&mode=AGENDA&src=MmRmMmVhNjdkMDk4ZGY0MzJhYWZhMWEzOTI5YTI0NDBlYzBhOTcyZDczYTBhMjhiOWYyZGEwZWY3NjFlYWNjZEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ODE3ODI2OGM0YTAyMDlmMjg1OTQxNDM1MzU1YzkwMzEwZjlmZDMzNWM2MjQ1ZDUxNzEzZDkyYzU3ZTU5ZDUwMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=OTliNmY3YzdmYmJkMjIzY2QzOTk3ZDkyNTIyMzA3Yzg0MmY4OGJiZmYzMGEwZGY4M2U3YzliODE5OWIwYzZiMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=MTc0ZjA5OThiNmZmNmJkMjNiNmU1ZTM5OWFhN2RlOTE4NTVjNzMwYzhmNTk5YThmMDliODNlZDc4ZmRjNmZlZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=Nzc4NjgyZWYxMDBjZmUwYTlmMzA3NzNiNjIxZjcyZmRiOWI4NjgwNTBmMWM0ZDg3ZGUxMTM3MDAwYWIyMzQzOEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=YzQxMGNmMDA4MDcyYzQ5NzNhNGZkMzNhNDBmNWUyM2EwYzcyNmE2YWU1YWU0OTYzNzkzYjg3NDFkZjk2YzY1YkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZW4uc2EjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23ef6c00&color=%23f6bf26&color=%239e69af&color=%234285f4&color=%23f626d0&color=%230b8043&color=%230b8043" style="border-width:0" width="335" height="500" frameborder="0" scrolling="no"></iframe>
    </div>
    </div>

</div>
 </Layout>
</template>

<script>
//import Layout from './layouts/Main.vue'
import { mapGetters } from "vuex";
//import ZA from "../data/za.json";
//import JOBS from "../data/jobs.json";
export default {
  name: 'AdminCalendar',
  components: {  },
  
  data() {
    return {
        admins: [],
        //name: "",
        email: "",
        jobs: "",
        tab: "allusers",
      
      }
    },
    created(){
      this.type = this.currentUserData.userType;
      this.userStatus = this.currentUserData.status;
      this.member = this.currentUserData.MainAdmin;
   
      //this.getAdminData();
  
    },
    
    computed: {
    ...mapGetters(["currentUserData"]),
    },
    methods: {
     
    setTab(tab) {
      this.tab = tab;
    },
  
    }
}


</script>